export const VOTING_GET_MY_VOTING_SESSIONS = "VOTING_GET_MY_VOTING_SESSIONS";
export const VOTING_DELETE_MY_VOTING_SESSION = "VOTING_DELETE_MY_VOTING_SESSION";
export const VOTING_ADDNEW_VOTING_SESSION = "VOTING_ADDNEW_VOTING_SESSION";
export const VOTING_UPDATE_VOTING_SESSION = "VOTING_UPDATE_VOTING_SESSION";
export const VOTING_REINDEX_SESSION = "VOTING_REINDEX_SESSION";

export const VOTING_GET_ALL_MY_VOTING_CATEGORIES = "VOTING_GET_ALL_MY_VOTING_CATEGORIES";
export const VOTING_DELETE_MY_VOTING_CATEGORY = "VOTING_DELETE_MY_VOTING_CATEGORY";
export const VOTING_ADDNEW_VOTING_CATEGORY = "VOTING_ADDNEW_VOTING_CATEGORY";
export const VOTING_UPDATE_VOTING_CATEGORY = "VOTING_UPDATE_VOTING_CATEGORY";

export const VOTING_GET_MY_VOTING_PARTICIPANTS = "VOTING_GET_MY_VOTING_PARTICIPANTS";
export const VOTING_DELETE_MY_VOTING_PARTICIPANT = "VOTING_DELETE_MY_VOTING_PARTICIPANT";
export const VOTING_ADDNEW_VOTING_PARTICIPANT = "VOTING_ADDNEW_VOTING_PARTICIPANT";
export const VOTING_UPDATE_VOTING_PARTICIPANT = "VOTING_UPDATE_VOTING_PARTICIPANT";
export const VOTING_GET_MY_VOTING_PARTICIPANTS_REPORT = "VOTING_GET_MY_VOTING_PARTICIPANTS_REPORT";

export const VOTING_GET_VOTING_SESSION_PRICING_WITH_TOPUP_FEE = "VOTING_GET_VOTING_SESSION_PRICING_WITH_TOPUP_FEE";
export const VOTING_TOPUP_VOTES_TO_PARTICIPANT = "VOTING_TOPUP_VOTES_TO_PARTICIPANT";
export const VOTING_DUPLICATE_SESSION = "VOTING_DUPLICATE_SESSION";
export const VOTING_GET_VOTING_SESSIONS = "VOTING_GET_VOTING_SESSIONS";

// Nomination actions (using backend implementation)
export const VOTING_GET_SESSION_NOMINEES = "VOTING_GET_SESSION_NOMINEES";
export const VOTING_UPDATE_NOMINEE_STATUS = "VOTING_UPDATE_NOMINEE_STATUS";
export const VOTING_MOVE_NOMINEE_TO_PARTICIPANT = "VOTING_MOVE_NOMINEE_TO_PARTICIPANT";
export const VOTING_DELETE_NOMINEE = "VOTING_DELETE_NOMINEE";

// Participant actions
export const PARTICIPANT_LOGIN = "PARTICIPANT_LOGIN";
export const PARTICIPANT_GET_DASHBOARD = "PARTICIPANT_GET_DASHBOARD";
export const PARTICIPANT_UPDATE_PROFILE = "PARTICIPANT_UPDATE_PROFILE";
export const PARTICIPANT_LOGOUT = "PARTICIPANT_LOGOUT";
export const PARTICIPANT_GET_TRANSACTIONS = "PARTICIPANT_GET_TRANSACTIONS";
export const PARTICIPANT_GET_INVOICES = "PARTICIPANT_GET_INVOICES";
export const PARTICIPANT_GET_INVOICE = "PARTICIPANT_GET_INVOICE";
export const PARTICIPANT_CREATE_INVOICE = "PARTICIPANT_CREATE_INVOICE";
export const PARTICIPANT_UPDATE_INVOICE = "PARTICIPANT_UPDATE_INVOICE";
export const PARTICIPANT_DELETE_INVOICE = "PARTICIPANT_DELETE_INVOICE";

// Participant Rewards actions
export const VOTING_GET_PARTICIPANT_REWARDS_HISTORY = "VOTING_GET_PARTICIPANT_REWARDS_HISTORY";
export const VOTING_ADD_PARTICIPANT_REWARD = "VOTING_ADD_PARTICIPANT_REWARD";
export const VOTING_UPDATE_PARTICIPANT_REWARD = "VOTING_UPDATE_PARTICIPANT_REWARD";
export const VOTING_DELETE_PARTICIPANT_REWARD = "VOTING_DELETE_PARTICIPANT_REWARD";

// Manual votes action
export const VOTING_ADD_VOTES_MANUALLY = "VOTING_ADD_VOTES_MANUALLY";
export const VOTING_GET_ADDED_VOTES_HISTORY = "VOTING_GET_ADDED_VOTES_HISTORY";